'use client'
import HomeHeader from '@/components/layout/HomeHeader'
import NewHeader from '@/components/layout/NewHeader'
import { IAppConfig } from '@/data/config/types'
import { useIsApp } from '@/lib/useIsApp'
import { usePathname } from 'next/navigation'

const links = ['/']

export default function HeaderSwitch({
  appConfig
}: {
  appConfig: IAppConfig
}): React.ReactNode {
  const { isApp } = useIsApp()
  const pathname = usePathname()
  const isMainPage = links.some((l) => l === pathname)
  const showAppHeader = !isMainPage && isApp //true für NewHeader

  return (
    <>
      {showAppHeader ? (
        <NewHeader appConfig={appConfig} />
      ) : (
        <HomeHeader appConfig={appConfig} />
      )}
    </>
  )
}
